import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { CircularProgress, FormControl, FormLabel } from '@mui/material';
import { t } from 'i18next';
import { autoCompleteSxProps } from './BakeasyAutoComplete';
import { useState, useEffect, Fragment } from 'react';

const filter = createFilterOptions<any>();

interface BakeasySelectAutoCompleteProps {
  key?: any;
  inputValue?: string;
  options?: any;
  value?: string;
  values?: string[] | undefined;
  label?: string;
  disabled?: boolean;
  multiple?: boolean;
  onChange: (newValue: any) => void;
  onAddClick?: (props: any) => void;
  required?: any;
}

export function BakeasyAutoCompleteTax(props: BakeasySelectAutoCompleteProps) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(null);
  const loading = open && options.length === 0;

  let newTax: any = { id: 0, name: t('ADD_NEW_TAX'), namee: 'Add New Tax' };
  let na: any = { id: 1, taxName: t('NOT_APPLICABLE') };

  function setOption() {
    let newOptions: {}[] =
      props?.options && props?.options?.length > 0 ? props?.options : [];
    setOptions(newOptions);
  }

  useEffect(() => {
    setOption();
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props?.label) : ''}
          {' *'}
        </FormLabel>
        <Autocomplete
          size="small"
          value={props?.value || null}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            if (!filtered?.includes(newTax)) {
              filtered.push(newTax);
            }
            if (!filtered?.includes(na)) {
              filtered.push(na);
            }

            return filtered;
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            if (typeof value === 'string' && value?.length !== 0) {
              return true;
            }
            return option?.taxName === value?.taxName;
          }}
          getOptionLabel={(option: any) => {
            if (option?.taxName) {
              return option?.taxName;
            }
            if (option?.name) {
              return option?.name;
            }
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={
                  props?.label ? t('SELECT') + ' ' + t(props?.label) : ''
                }
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            if (typeof value === 'string' && value?.length > 0) {
              props?.onChange(value);
            }

            if (typeof value === 'string' && value?.length === 0) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue: any) => {
            if (
              typeof newValue === 'object' &&
              newValue?.id === 0 &&
              newValue?.namee === 'Add New Tax'
            ) {
              if (props?.onAddClick) {
                props?.onAddClick(newValue);
              }
              return;
            }

            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </Fragment>
  );
}

export function BakeasyAutoCompleteShippingMethod(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(null);
  const loading = open && options.length === 0;

  let newShippingMethod: any = { id: 0, name: 'Add New Shipping Method' };

  function setOption() {
    let newOptions: {}[] =
      props?.options && props?.options?.length > 0 ? props?.options : [];
    setOptions(newOptions);
  }

  useEffect(() => {
    setOption();
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props.label) : t('SHIPPING_METHOD')}
          {' *'}
        </FormLabel>
        <Autocomplete
          size="small"
          value={props?.value || null}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            if (!filtered?.includes(newShippingMethod)) {
              filtered.push(newShippingMethod);
            }

            return filtered;
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            return option?.shippingMethodName === value?.shippingMethodName;
          }}
          getOptionLabel={(option: any) => {
            if (option?.shippingMethodName) {
              return option?.shippingMethodName;
            }
            if (option?.name) {
              return option?.name;
            }
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT') + t('SHIPPING_METHOD')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            if (typeof value === 'string' && value?.length > 2) {
              props?.onChange(value);
            }

            if (typeof value === 'string' && value?.length === 0) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue: any) => {
            if (
              typeof newValue === 'object' &&
              newValue?.id === 0 &&
              newValue?.name === t('ADD_NEW_SHIPPING_METHOD')
            ) {
              if (props?.onAddClick) {
                props?.onAddClick(newValue);
              }
              return;
            }

            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </Fragment>
  );
}
